import { messages_pt } from './translations/pt'
import { getLocales } from 'react-native-localize'

let appStrings = messages_pt
if (getLocales()[0].languageCode === 'pt') {
  appStrings = messages_pt
}

export const messages = appStrings
